import React, {Component} from 'react';
import {AJAX, close_popup, show_popup} from "../functions";
import {showProgressBarPopup} from "../popups/ProgressBarPopup";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import $ from 'jquery';


class UploadLicensePopup extends Component {
    constructor(props) {super(props);}
    goBack() {close_popup();}
    sendPhoto(e) {this.props.sendPhoto(e)}
    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="row mx-3 my-2">
                        <div className="col-12 text-center">
                            <p>Upload image of your e-license here</p>
                        </div>
                    </div>
                    <div className="row mx-3 mb-2">
                        <input type="file" id="photo_upload" accept="image/*"
                               className="form-control mb-4" name="photo"
                               onClick={()=>{return true;}}
                               onChange={this.sendPhoto.bind(this)}/>
                        <label htmlFor="photo_upload"
                               className="base-input">UPLOAD FILE</label>
                    </div>
                    <div className="row mx-3 mb-3">
                        <div className="go-btn go-back mx-auto" onClick={this.goBack.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}

class UploadPhoto extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.sendPhoto = this.sendPhoto.bind(this);
        this.onBlurHandler = this.onBlurHandler.bind(this);
        this.openGallery = this.openGallery.bind(this);
        this.state = {
            file_upload: null,
            uploadPercent: 0,
            url: "",
            dirty: false,
            eLicense:false,
            isMobile: /Mobi|Android/i.test(navigator.userAgent) // определяем мобильное устройство
        };
    }

    componentDidUpdate(previousProps) {
        if (this.props.reset_photo_fields && previousProps.reset_photo_fields !== this.props.reset_photo_fields) {
            this.setState({file_upload: null, uploadPercent: 0, url: ""});
            this.props.handleSetSomeBlock('reset_photo_fields', false);
        }
    }

    onBlurHandler() {
        this.setState({dirty: true});
        this.props.handleUploadPhoto(this.props.photo_key, '', true, this.state.eLicense);
    }

    setData(field_name, value) {
        this.setState({url: value});
        this.props.handleUploadPhoto(this.props.photo_key, value, this.state.dirty, this.state.eLicense);
    }

    sendPhoto(e) {
        let t = this;
        let file = e.target.files[0];
        let is_file_upload =  e.target.id === 'photo_upload';

        if (!file) return false;


        let params = {
            photo_key: t.props.photo_key,
            photo_type: this.props.photo_type,
            action: 'api/booking/send_photo_booking',
            files: { photo: file }
        };

        AJAX(bf_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: () => showProgressBarPopup(t.state.uploadPercent),

            func_callback: function (resp) {
                t.setState({uploadPercent: 100}, () => {
                    close_popup();
                });
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    if (resp.data.url)
                        t.setState({file_upload: true, uploadPercent: 0});
                    else
                        t.setState({file_upload: false, uploadPercent: 0});
                    if (t.props.photo_type === 'license' && is_file_upload){
                        t.setState({eLicense: true});
                    }
                    else {
                        if (t.props.photo_type === 'license' && !is_file_upload ){
                            t.setState({eLicense: false});
                        }
                    }
                    t.setData(t.props.photo_key, resp.data.url + '|' + resp.data.bytes + '|' + resp.data.format + '|' + resp.data.resource_type);
                }
                else {
                    if (resp.errors.length) {
                        showPopupWithGoBack(resp.errors);
                    }
                }
            },
            func_error: function (resp) {
                close_popup();
                showPopupWithGoBack(resp.message);
            },
            func_progress: function (evt) {
                if (evt.lengthComputable) {
                    let percentComplete = Math.round(evt.loaded / evt.total * 100);
                    if (percentComplete >= 100) percentComplete = 98;
                    t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));
                }
            }
        });
    }

    openGallery() {
        // Убираем атрибут capture и эмулируем клик для загрузки из галереи
        this.fileInputRef.current.removeAttribute('capture');
        this.fileInputRef.current.click();
    }

    render() {
        let photo_types = {
            license: "Driver's License",
            back: "Back of Driver’s License",
            selfie: "Selfie While Holding Driver's License"
        };

        return (
            <>
                <input
                    type="file"
                    ref={this.fileInputRef}
                    accept="image/*"
                    capture="camera"
                    name={this.props.photo_key}
                    id={this.props.photo_key}
                    onChange={this.sendPhoto}
                    onBlur={this.onBlurHandler}
                />

                <label
                    htmlFor={this.props.photo_key}
                    className={'upload-file ' + (this.state.file_upload ? 'upload-file-success' : '')}
                    onClick={() => {
                        if (!this.fileInputRef.current.hasAttribute('capture')) {
                            this.fileInputRef.current.setAttribute('capture', 'camera');
                        }
                    }}
                >
                    {!this.state.file_upload
                        ? "Upload " + photo_types[this.props.photo_type]
                        : "Replace " + photo_types[this.props.photo_type]}
                    {this.props.photo_type !== 'back' ? <span>&nbsp;*</span> : <span></span>}
                </label>
                {/* this.state.isMobile && (
                    <a className={'upload-from-gallery'}  onClick={this.openGallery} style={{"marginTop":"14px","float":"right","paddingRight":0 }}>
                        { (!this.state.file_upload
                            ? "Upload "
                            : "Replace ") + "from gallery"}
                    </a>
                ) */}
                {
                    (this.props.photo_type === 'license') ? (
                        <a className="upload-from-gallery" onClick={event => {event.preventDefault(); show_popup(<UploadLicensePopup sendPhoto={event=>this.sendPhoto( event)}/>, {auto_close:false})}}>{!this.state.file_upload
                            ? "Upload" : "Replace"} E-License</a>
                    ) : ('')
                }
                {this.props.dirty && this.props.error && (
                    <small style={{ marginTop: "11px" }} className="form-control-feedback d-block">
                        {this.props.error}
                    </small>
                )}
            </>
        );
    }
}

export default UploadPhoto;
